import { useEffect, useState } from "react";
import styled from "styled-components";
import LoadingSection from "../../helperComponents/LoadingSection";
import NomenclatureOfDispute from "../../pages/loggedIn/nomenclature/NomenclatureOfDispute";
import NomenclatureOfAbsence from "../../pages/loggedIn/nomenclature/NomenclatureOfAbsence";
import NomenclatureOfVacation from "../../pages/loggedIn/nomenclature/NomenclatureOfVacation";
import NomenclatureOfComment from "../../pages/loggedIn/nomenclature/NomenclatureOfComment";
import AnimatedPillTabs from "../../pages/loggedOut/landingPage/loggedOutHomeForApp/AnimatedPillTabs";
import AddOrEditAbsenceModular from "../../pages/loggedIn/absence/AddOrEditAbsenceModular";
import { useTranslation } from "react-i18next";
import AddOrEditCommentModular from "../../pages/loggedIn/comment/AddOrEditCommentModular";
import AddOrEditDisputeModular from "../../pages/loggedIn/disputes/AddOrEditDisputeModular";
import AddOrEditVacationModular from "../../pages/loggedIn/vacation/AddOrEditVacationModular";
import CustomButton from "../../helperComponents/CustomButton";
import goTo from "../../../controllers/goTo";

let options = [
  { label: "Absence", value: "ABSENCE" },
  { label: "Commentaire", value: "COMMENT" },
  { label: "Contentieux", value: "DISPUTE" },
  { label: "Congé", value: "VACATION" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 25px;

  @media (max-width: 900px) {
    padding: 15px;
  }
`;
const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* padding: 25px; */
`;

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* padding: 25px; */
`;

export default function ProfileQuickActionPopup({
  userID,
  callback,
  defaultSectionType,
}) {
  const { t } = useTranslation();
  const [inputSectionIndex, setInputSectionIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  let activeSection = options[inputSectionIndex];

  useEffect(() => {
    if (defaultSectionType) {
      let i = 0;

      for (let item of options) {
        if (item.value == defaultSectionType) setInputSectionIndex(i);
        i++;
      }
    }
  }, [defaultSectionType]);

  if (loading)
    return (
      <Container>
        <LoadingSection />
      </Container>
    );

  return (
    <Container>
      <InputSection>
        <AnimatedPillTabs
          tabs={options}
          activeIndex={inputSectionIndex}
          setActiveIndex={setInputSectionIndex}
        />
        {getInputComponent()}
      </InputSection>
      <br />
      <br />
      <Sections>{getBottomSection()}</Sections>
      <br />
      <br />
      <CustomButton onClick={goTo(`/employee/${userID}`)}>Profile</CustomButton>
    </Container>
  );

  function getBottomSection() {
    if (activeSection.value == "ABSENCE") {
      return <NomenclatureOfAbsence callback={done} userID={userID} />;
    } else if (activeSection.value == "VACATION") {
      return <NomenclatureOfVacation callback={done} userID={userID} />;
    } else if (activeSection.value == "COMMENT") {
      return <NomenclatureOfComment callback={done} userID={userID} />;
    } else if (activeSection.value == "DISPUTE") {
      return <NomenclatureOfDispute callback={done} userID={userID} />;
    }
  }

  function getInputComponent() {
    if (activeSection.value == "ABSENCE") {
      return (
        <AddOrEditAbsenceModular
          purpose={"ADD"}
          userID={userID}
          loading={loading}
          setLoading={setLoading}
          callback={done}
        />
      );
    } else if (activeSection.value == "VACATION") {
      return (
        <AddOrEditVacationModular
          purpose={"ADD"}
          userID={userID}
          loading={loading}
          setLoading={setLoading}
          callback={done}
        />
      );
    } else if (activeSection.value == "DISPUTE") {
      return (
        <AddOrEditDisputeModular
          purpose={"ADD"}
          userID={userID}
          loading={loading}
          setLoading={setLoading}
          callback={done}
        />
      );
    } else if (activeSection.value == "COMMENT") {
      return (
        <AddOrEditCommentModular
          purpose={"ADD"}
          userID={userID}
          loading={loading}
          setLoading={setLoading}
          callback={done}
        />
      );
    }
  }

  function done() {
    window.popupAlert(t("done"));
    callback();
  }
}
